import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { LogoCloud } from './components/LogoCloud';
import { ValueSection } from './components/ValueSection';
import { Services } from './components/Services';
import { Process } from './components/Process';
import { Results } from './components/Results';
import { Projects } from './components/Projects';
import { Testimonials } from './components/Testimonials';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-canvas font-sans antialiased" data-id="element-0" data-mp="2mjzlb0sxjhkg">
      <Header data-id="element-1" data-mp="31c9y2cr4hfvo" />
      <main data-id="element-2" data-mp="31ctf7r8y808n">
        <Hero data-id="element-3" data-mp="2wk0a329kipw1" />
        <LogoCloud data-id="element-4" data-mp="2wk9y4kb1ymz3" />
        <ValueSection data-id="element-5" data-mp="2wiyxuugtfxcq" />
        <Services data-id="element-6" data-mp="2wifgpfyzpczr" />
        <Process data-id="element-7" data-mp="2whxabqim5ie4" />
        <Results data-id="element-8" data-mp="28ufoscpxzgjl" />
        <Projects data-id="element-9" data-mp="28tw44o8wqe1v" />
        <Testimonials data-id="element-10" data-mp="28te37ebavbnm" />
        <CTA data-id="element-11" data-mp="28sl3uyeo7ofi" />
      </main>
      <Footer data-id="element-12" data-mp="23vciyq2516ak" />
    </div>;
}